import { Injectable } from '@angular/core';
import { ApiUrlHelper } from '../api-url-helper';
import { VideoTransFormer } from '../../_transformers/video.transformer';
import { HttpClientHelper } from '../http-helper';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: "root"
})
export class NavbarLinksService {
    private cached = {};

    private loadings = [];

    private links = {};
    private _linksService = new BehaviorSubject<any>({});
    linksSource$ = this._linksService.asObservable();

    private secondLinks = {};
    private _secondLinksService = new BehaviorSubject<any>({});
    secondLinksSource$ = this._secondLinksService.asObservable();

    private newMainMenu = {};
    private _newMainMenuService = new BehaviorSubject<any>({});
    newMainMenuSource$ = this._newMainMenuService.asObservable();

    //public hash = new Date().getTime();
    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _videoTransFormer: VideoTransFormer,
        private _httpClientHelper: HttpClientHelper
    ) {
    }

    getNavbarLinks(cid = '0,1') {
        if (this.loadings.includes(cid)) {
            return;
        }
        const apiURL = this._apiUrlHelper.urlBuilder('nav-main-links', { cid: cid });
        this.loadings.push(cid);
        var dateTime = new Date().getTime();
        this._httpClientHelper.getWithCache(apiURL)
            .subscribe(r => {
                //console.log(r);
                this.links[cid] = {
                    items: r,
                    expire: dateTime + 20 * 1000
                };
                this._linksService.next(this.links)
                this.loadings = this.loadings.filter(l => l !== cid);
            });
    }

    getNavbarSecondLinks(cid = '0,1', pageSize = 10) {
        const cacheKey = 'sec' + cid + '_' + pageSize;
        if (this.loadings.includes(cacheKey)) {
            return;
        }
        this.loadings.push(cacheKey);
        var dateTime = new Date().getTime();
        const apiURL = this._apiUrlHelper.urlBuilder('nav-second-links', { cid: cid, pageSize });
        this._httpClientHelper.getWithCache(apiURL)
            .subscribe(res => {
                this.loadings = this.loadings.filter(l => l !== cacheKey);
                this.secondLinks[cacheKey] = { result: res, expire: dateTime + 20 * 1000 };
                this._secondLinksService.next(this.secondLinks)
            })

    }

    getNewNavbarLinks(cid = '0,1') {
        if (this.loadings.includes(cid)) {
            return;
        }
        const apiURL = this._apiUrlHelper.urlBuilder('new-main-menu', { cid: cid });
        this.loadings.push(cid);
        var dateTime = new Date().getTime();
        this._httpClientHelper.getWithCache(apiURL)
            .subscribe(r => {
                //console.log(r);
                this.links[cid] = {
                    items: r,
                    expire: dateTime + 20 * 1000
                };
                this._newMainMenuService.next(this.links)
                this.loadings = this.loadings.filter(l => l !== cid);
            });
    }

}
